import gql from 'graphql-tag';
import {
  alarmScheduleTableFields,
  alarmCentralDeviceFields,
  alarmScheduleTableAssignmentFields,
  alarmCondominiumStatusFields,
  alarmDeviceScheduleResolutionFields,
} from './fragments';

export const getAlarmScheduleTablesByCondominium = gql`
  query alarmScheduleTablesByCondominium($condominiumId: Int!) {
    alarmScheduleTablesByCondominium(condominiumId: $condominiumId) {
      ...AlarmScheduleTableFields
    }
  }
  ${alarmScheduleTableFields}
`;

export const getAlarmScheduleTablesByPartner = gql`
  query alarmScheduleTablesByPartner($partnerId: Int!) {
    alarmScheduleTablesByPartner(partnerId: $partnerId) {
      ...AlarmScheduleTableFields
    }
  }
  ${alarmScheduleTableFields}
`;

export const getAlarmCentralDevicesByCondominium = gql`
  query alarmCentralDevicesByCondominium($condominiumId: Int!) {
    alarmCentralDevicesByCondominium(condominiumId: $condominiumId) {
      ...AlarmCentralDeviceFields
    }
  }
  ${alarmCentralDeviceFields}
`;

export const getAlarmScheduleAssignmentsByCondominium = gql`
  query alarmScheduleAssignmentsByCondominium($condominiumId: Int!) {
    alarmScheduleAssignmentsByCondominium(condominiumId: $condominiumId) {
      ...AlarmScheduleTableAssignmentFields
    }
  }
  ${alarmScheduleTableAssignmentFields}
`;

export const getAlarmStatusByCondominium = gql`
  query alarmStatusByCondominium($condominiumId: Int!) {
    alarmStatusByCondominium(condominiumId: $condominiumId) {
      ...AlarmCondominiumStatusFields
    }
  }
  ${alarmCondominiumStatusFields}
`;

export const getAlarmScheduleResolutionByCondominium = gql`
  query alarmScheduleResolutionByCondominium($condominiumId: Int!) {
    alarmScheduleResolutionByCondominium(condominiumId: $condominiumId) {
      ...AlarmDeviceScheduleResolutionFields
    }
  }
  ${alarmDeviceScheduleResolutionFields}
`;
